"use strict";

var _classCallCheck = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _inherits = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _wrapNativeSuper = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onErrorRetry = exports.ArgumentsError = exports.NotFoundError = void 0;

var NotFoundError = /*#__PURE__*/function (_Error) {
  _inherits(NotFoundError, _Error);

  var _super = _createSuper(NotFoundError);

  function NotFoundError() {
    _classCallCheck(this, NotFoundError);

    return _super.apply(this, arguments);
  }

  return NotFoundError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.NotFoundError = NotFoundError;

var ArgumentsError = /*#__PURE__*/function (_Error2) {
  _inherits(ArgumentsError, _Error2);

  var _super2 = _createSuper(ArgumentsError);

  function ArgumentsError() {
    _classCallCheck(this, ArgumentsError);

    return _super2.apply(this, arguments);
  }

  return ArgumentsError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.ArgumentsError = ArgumentsError;

var onErrorRetry = function onErrorRetry(err, _, __, revalidate, revalidateOpts) {
  if (err instanceof NotFoundError) {
    // Don't retry for 404 records
    return;
  }

  if (err instanceof ArgumentsError) {
    // Don't retry for invalid arguments
    return;
  }

  if (revalidateOpts.retryCount || 5 < 4) {
    // Retry with error other than not found
    revalidate(revalidateOpts);
  }
};

exports.onErrorRetry = onErrorRetry;